export default function DiferenciaisSection() {
  const diferenciais = [
    {
      icon: 'ri-global-line',
      title: '100% Online',
      description: 'Participe de qualquer lugar via Zoom, com total flexibilidade'
    },
    {
      icon: 'ri-calendar-line',
      title: '10 Encontros Mensais',
      description: 'Encontros de 4 horas com conteúdo profundo e transformador'
    },
    {
      icon: 'ri-award-line',
      title: 'Certificação',
      description: 'Certificado de conclusão validando seu desenvolvimento'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Metodologia Salto Alto',
      description: 'Baseado na renomada imersão de liderança feminina'
    },
    {
      icon: 'ri-live-line',
      title: 'Aulas ao Vivo',
      description: 'Interação em tempo real com especialistas e colegas'
    },
    {
      icon: 'ri-tools-line',
      title: 'Ferramentas Práticas',
      description: 'Recursos aplicáveis imediatamente na sua carreira'
    },
    {
      icon: 'ri-team-line',
      title: 'Especialistas Experientes',
      description: 'Aprenda com líderes reconhecidas no mercado'
    },
    {
      icon: 'ri-group-line',
      title: 'Comunidade Exclusiva',
      description: 'Networking com mulheres líderes de todo o Brasil'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {diferenciais.map((item, index) => (
            <div
              key={index}
              className="bg-white border border-purple-100 rounded-2xl p-8 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-4">
                <i className={`${item.icon} text-gold-500 text-4xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-purple-900 mb-3">{item.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
